var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c_nodata"},[_c('img',{staticClass:"c_nodata-pic",attrs:{"src":require('@/assets/nodata.svg')}}),_c('div',{staticClass:"c_nodata-text"},[_vm._v(_vm._s(_vm.text || _vm.$t('normal.nodata')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }